import Ocr from "../../../static/assets/gif/ocr.gif"

const projetos = {
  en: {
    projetos: [
      {
        titulo: "Urbla | App e API ",
        resumo: `
      Flash Cards`,
        descricao: `Flash Cards App`,
        link:
          "https://www.youtube.com/watch?v=HDmo-uDJhhg&feature=emb_logo&ab_channel=LorenaKauanePorphirio",
        tecnologias: [
          "Node",
          "TypeScript",
          "Express",
          "MongoDB",
          "React Native",
          "Styled components",
          "Context Api",
          "React Navigation",
        ],
        linkBack: "",
        linkFront: "",
        src:
          "https://www.youtube.com/watch?v=HDmo-uDJhhg&feature=emb_logo&ab_channel=LorenaKauanePorphirio",
      },
      {
        titulo: "Dr Boss | App e API ",
        resumo: `
      Consultation management application for health professionals.`,
        descricao: `Consultation management application for healthcare professionals, where it is possible to have the management of your patients, consultation management and financial transactions`,
        link: "https://www.instagram.com/p/B9Y1etcAkdS/",
        tecnologias: [
          "Node",
          "Express",
          "Sequelize",
          "multer",
          "React Native",
          "Styled components",
          "Redux",
          "React Navigation",
        ],
        linkBack: "",
        linkFront: "",
        src: "https://www.instagram.com/p/B9Y1etcAkdS/",
      },
      {
        titulo: "Distribua facil | Web e API ",
        resumo: `
        Eyeglasses and sales registration management software.`,
        descricao: `Software for managing eyeglasses and orders on demand, this application was developed together with my great friend Felipe Breve Tedardi.`,
        link: "",
        tecnologias: [
          "Node",
          "Express",
          "Sequelize",
          "NodeMailer",
          "multer",
          "Vue",
          "Vuetify",
          "nginx",
        ],
        linkBack: "",
        linkFront: "",
        src: "https://media.giphy.com/media/XCxwqF8G3gHfPP6Ihc/giphy.gif",
      },
      {
        titulo: "Ocr | API ",
        resumo: "OCR project using lib tesseract.js.",
        descricao: "OCR project using lib tesseract.js.",
        tecnologias: ["Node", "Express", "Tesseract"],
        linkBack: "https://github.com/LorenaKauane/ocr-node-api",
        src: Ocr,
      },
    ],
  },
  pt: {
    projetos: [
      {
        titulo: "Urbla | App e API ",
        resumo: `
      Flash Cards`,
        descricao: `Flash Cards App`,
        link:
          "https://www.youtube.com/watch?v=HDmo-uDJhhg&feature=emb_logo&ab_channel=LorenaKauanePorphirio",
        tecnologias: [
          "Node",
          "TypeScript",
          "Express",
          "MongoDB",
          "React Native",
          "Styled components",
          "Context Api",
          "React Navigation",
        ],
        linkBack: "",
        linkFront: "",
        src:
          "https://www.youtube.com/watch?v=HDmo-uDJhhg&feature=emb_logo&ab_channel=LorenaKauanePorphirio",
      },
      {
        titulo: "Dr Boss | Aplicativo e API ",
        resumo:
          "Aplicativo de gestão de consultas para profissionais da saúde.",
        descricao:
          "Aplicativo de gestão de consultas para profissionais da saúde, onde e possivel ter a gestão de seus pacientes, gestão de consultas e movimentação financeira",
        link: "https://www.instagram.com/p/B9Y1etcAkdS/",
        tecnologias: [
          "Node",
          "Express",
          "Sequelize",
          "multer",
          "React Native",
          "Styled components",
          "Redux",
          "React Navigation",
        ],
        linkBack: "",
        linkFront: "",
        src: "https://www.instagram.com/p/B9Y1etcAkdS/",
      },
      {
        titulo: "Distribua facil | Web e API ",
        resumo: "Software de gestão de cadastro de óculos e vendas.",
        descricao:
          "Software de gestão de cadastro de óculos e pedidos sob demenda, essa aplicação foi  desenvolvido juntamente com meu grande amigo Felipe Breve Tedardi.",
        link: "",
        tecnologias: [
          "Node",
          "Express",
          "Sequelize",
          "NodeMailer",
          "multer",
          "Vue",
          "Vuetify",
          "nginx",
        ],
        linkBack: "",
        linkFront: "",
        src: "https://media.giphy.com/media/XCxwqF8G3gHfPP6Ihc/giphy.gif",
      },
      {
        titulo: "Ocr | API ",
        resumo: "Projeto de OCR utilizando a lib tesseract.js.",
        descricao: "Projeto de OCR utilizando a lib tesseract.js",
        tecnologias: ["Node", "Express", "Tesseract"],
        linkBack: "https://github.com/LorenaKauane/ocr-node-api",
        src: Ocr,
      },
    ],
  },
}

// const projetos = [
//   {
//     titulo: "Dr Boss | Aplicativo e API ",
//     resumo: "Aplicativo de gestão de consultas para profissionais da saúde.",
//     descricao:
//       "Aplicativo de gestão de consultas para profissionais da saúde, onde e possivel ter a gestão de seus pacientes, gestão de consultas e movimentação financeira",
//     link: "https://www.instagram.com/p/B9Y1etcAkdS/",
//     tecnologias: [
//       "Node",
//       "Express",
//       "Sequelize",
//       "multer",
//       "React Native",
//       "Styled components",
//       "Redux",
//       "React Navigation",
//     ],
//     linkBack: "",
//     linkFront: "",
//     src: "https://www.instagram.com/p/B9Y1etcAkdS/",
//   },
//   {
//     titulo: "Distribua facil | Web e API ",
//     resumo: "Software de gestão de cadastro de óculos e vendas.",
//     descricao:
//       "Software de gestão de cadastro de óculos e pedidos sob demenda, essa aplicação foi  desenvolvido juntamente com meu grande amigo Felipe Breve Tedardi.",
//     link: "",
//     tecnologias: [
//       "Node",
//       "Express",
//       "Sequelize",
//       "NodeMailer",
//       "multer",
//       "Vue",
//       "Vuetify",
//       "nginx",
//     ],
//     linkBack: "",
//     linkFront: "",
//     src: "https://media.giphy.com/media/XCxwqF8G3gHfPP6Ihc/giphy.gif",
//   },
//   {
//     titulo: "Ocr | API ",
//     resumo: "Projeto de OCR utilizando a lib tesseract.js.",
//     descricao: "Projeto de OCR utilizando a lib tesseract.js",
//     tecnologias: ["Node", "Express", "Tesseract"],
//     linkBack: "https://github.com/LorenaKauane/ocr-node-api",
//     src: Ocr,
//   },
//   {
//     titulo: "Home Decor | Aplicativo e API",
//     resumo: "Aplicativo para cadastrar decoração de casa.",
//     descricao:
//       "Aplicativo para cadastro de decoração de casa, onde o usuario consegue cadastrar um novo post com upload de imagem",
//     tecnologias: [
//       "Node",
//       "Express",
//       "MongoDB",
//       "multer",
//       "JEST",
//       "React Native",
//       "Redux",
//       "React Navigation",
//     ],
//     linkBack: "https://github.com/LorenaKauane/ocr-node-api",
//     linkFront: "https://github.com/LorenaKauane/homedecorapp",
//     src: CadastroDeCoisasDeCasa,
//   },
// ]

export default projetos
